const config = require('./config/i18n');

const dayjs = require('dayjs');
const localeData = require('dayjs/plugin/localeData');
const relativeTime = require('dayjs/plugin/relativeTime');
const localizedFormat = require('dayjs/plugin/localizedFormat');
const capitalize = require('lodash/fp/capitalize');

dayjs.extend(relativeTime);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs().localeData();

require('dayjs/locale/fr');

module.exports = {
  ...config,
  locales: ['en', 'fr'],
  defaultLocale: 'en',
  pages: {
    '*': ['header', 'footer', 'auth', 'common', 'common.seo', 'common.table', 'common.calendar'],
    'rgx:/blog': ['blog.common'], // using regex to match case-studies index and single page, see: https://github.com/aralroca/next-translate#3-configuration
    '/calendar': ['common.calendar'],
    '/admin/events': ['common.calendar'],
    '/': ['common.calendar'],
    '/user/subscription': ['common.calendar'],
    '/user/paywall': ['common.calendar'],
    // '*': ['common', 'header', 'footer', 'follow-us'],
    // '/': ['homepage', 'instances'],
    // 'rgx:/admin': ['common.table'], // using regex to match case-studies index and single page, see: https://github.com/aralroca/next-translate#3-configuration
    // '/stats': ['stats'],
    // '/budget': ['budget'],
    // '/media': ['media'],
    // '/subscribe': ['subscribe'],
  },
};
